module.exports = __webpack_public_path__ + "static/media/RescueAtLakeWildJacket.91c29e52.jpg";